import { __assign } from "tslib";
import { markdownToDraft as markdownToDraftLib } from 'markdown-draft-js';
import { linkify } from 'remarkable/linkify';
import { officialEmotes } from '../../DaEditor/plugins/emote/official-emotes';
import escapeRegExp from 'lodash/escapeRegExp';
import { genKey } from 'wix-rich-content-editor-common';
export function markdownToDraft(markdown) {
    var raw = markdownToDraftLib(markdown, {
        remarkablePlugins: [mentionPlugin, linkify, officalEmotePlugin],
        blockEntities: {
            mention_open: function (item) {
                return {
                    type: 'mention',
                    mutability: 'IMMUTABLE',
                    data: {
                        mention: {
                            name: item === null || item === void 0 ? void 0 : item.name,
                        },
                    },
                };
            },
            link_open: function (item) {
                return {
                    type: 'LINK',
                    mutability: 'MUTABLE',
                    data: {
                        url: item.href,
                        target: '_blank',
                        rel: 'nofollow noopener',
                    },
                };
            },
            emote_open: function (item) {
                return {
                    type: 'DA_OFF_EMOTE',
                    mutability: 'IMMUTABLE',
                    data: { emote: (item === null || item === void 0 ? void 0 : item.id) + " " },
                };
            },
        },
        blockTypes: {
            heading_open: function (item) {
                var type = "header-" + {
                    1: 'two',
                    2: 'two',
                    3: 'three',
                    4: 'three',
                    5: 'three',
                    6: 'three',
                }[item === null || item === void 0 ? void 0 : item.hLevel];
                return {
                    type: type,
                    text: '',
                };
            },
        },
        remarkablePreset: 'commonmark',
        // https://github.com/jonschlinkert/remarkable/tree/master/lib
        remarkableOptions: {
            disable: {
                core: [
                    'abbr',
                    'abbr2',
                    'footnote_tail',
                    'references',
                    'replacements',
                    'smartquotes',
                ],
                inline: [
                    'autolink',
                    'backticks',
                    'del',
                    'entity',
                    'escape',
                    'footnote_inline',
                    'footnote_ref',
                    'htmltag',
                    'ins',
                    'mark',
                    'sub',
                    'sup',
                ],
                block: [
                    'code',
                    'deflist',
                    'fences',
                    'footnote',
                    'hr',
                    'htmlblock',
                    'table',
                ],
            },
        },
    });
    // Lib sometimes produces bad blocks...
    raw.blocks = raw.blocks.map(function (block) {
        return __assign({ depth: 0, type: 'unstyled', text: '', key: genKey(), data: {}, entityRanges: [], inlineStyleRanges: [] }, block);
    });
    return raw;
}
/**
 * Remarkable plugin for mentions, this is taken from the markdown-draft-js tests
 *
 * @param remarkable
 */
function mentionPlugin(remarkable) {
    remarkable.inline.ruler.push('mention', function (state, silent) {
        var UsernameRegex = /^@([A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9])/g;
        var match = UsernameRegex.exec(state.src.slice(state.pos));
        if (!match) {
            return false;
        }
        if (!silent) {
            state.push({
                type: 'mention_open',
                name: match[1],
                id: match[2],
                level: state.level,
            });
            state.push({
                type: 'text',
                content: "@" + match[1],
                level: state.level + 1,
            });
            state.push({
                type: 'mention_close',
                level: state.level,
            });
        }
        state.pos += match[0].length;
        return true;
    }, {});
}
function officalEmotePlugin(remarkable) {
    // Extract the codes
    var officialEmotesCodes = Object.keys(officialEmotes);
    var regexWrapper = function (emotes) { return "^" + emotes; };
    // This creates a single huge! regex for all emotes
    var officialEmotesRegex = new RegExp(regexWrapper(officialEmotesCodes.map(escapeRegExp).join('|')));
    remarkable.inline.ruler.push('emote', function (state, silent) {
        var match = officialEmotesRegex.exec(state.src.slice(state.pos));
        if (!match) {
            return false;
        }
        if (!silent) {
            state.push({
                type: 'emote_open',
                id: match[0],
                level: state.level,
            });
            state.push({
                type: 'text',
                content: "" + match[0],
                level: state.level + 1,
            });
            state.push({
                type: 'emote_close',
                level: state.level,
            });
        }
        // Move state past this match
        state.pos += match[0].length;
        return true;
    }, {});
}
//# sourceMappingURL=markdown.js.map